import { Button } from "components/Button";
import { InputFormField } from "components/InputFormField";
import { Loading } from "components/Loading";
import { PlaceHolderNotExists } from "components/PlaceholderNotExists";
import { TableModifiedCards } from "components/TableModified/TableModifiedCards";
import { TableModifiedFilters } from "components/TableModified/TableModifiedFilters";
import { TableModifiedPagination } from "components/TableModified/TableModifiedPagination";
import { TableModifiedTable } from "components/TableModified/TableModifiedTable";
import React from "react";
import { TableSearch } from "../styles";
import { useTicketIngestionsTable } from "./useTicketIngestionsTable";

const tableHead = [
  "Nome",
  "CPF",
  "E-mail",
  "Ingresso",
  "Status",
  "Evento",
  "Origem",
  "Recebido em",
  " ",
];

export const TicketIngestionsTable: React.FC = () => {
  const {
    loading,
    error,
    properties,
    ticketRows,
    totalCount,
    tableFilters,
    searchText,
    searchTextFormRef,
    pageNumber,
    rowsPerPage,
    exporting,
    handleExportCsv,
    handleSearchTextFormSubmit,
    handleFilterChange,
    handleFilterRemove,
    handleSearchTextRemove,
    handleClearFilters,
    handlePageSelected,
    handleRowsPerPageChange,
    handleRowClick,
  } = useTicketIngestionsTable();

  return (
    <div>
      <h2 style={{ marginBottom: "1rem" }}>Ingressos de parceiros</h2>

      <TableSearch onSubmit={handleSearchTextFormSubmit} ref={searchTextFormRef}>
        <InputFormField
          label="Buscar por nome, e-mail, CPF ou id do ingresso"
          name="searchText"
          marginBotton={"0"}
          defaultValue={searchText}
          block={true}
        />
        <Button label="Buscar" typeBtn="blue" type="submit" block={false} />
        <Button
          label="Exportar CSV"
          typeBtn="outline"
          type="button"
          onClick={handleExportCsv}
          load={exporting}
          block={false}
        />
      </TableSearch>

      <TableModifiedFilters
        filters={tableFilters}
        searchTextFilter={searchText}
        onFilterChange={handleFilterChange}
        onFilterRemove={handleFilterRemove}
        onSearchTextRemove={handleSearchTextRemove}
      />

      {loading ? (
        <Loading />
      ) : error ? (
        <PlaceHolderNotExists title="Erro ao se comunicar com o servidor" />
      ) : (
        <>
          <TableModifiedCards properties={properties} />
          <TableModifiedTable
            headerColumns={tableHead}
            rows={ticketRows}
            onRowClick={handleRowClick}
            onClearFilters={handleClearFilters}
          />
        </>
      )}

      {totalCount > 0 ? (
        <TableModifiedPagination
          totalItemsCount={totalCount}
          pageNumber={pageNumber}
          rowsPerPage={rowsPerPage}
          onPageSelected={handlePageSelected}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      ) : null}
    </div>
  );
};
